import $ from "./lib/qsa.js";

let cells = $(".waffle .cell");
let note = $.one(".waffle .individual");

function onCellEnter(e) {
  let id = e.target.dataset.id;
  let data = window.EMAILS.find(message => message.id == id);
  if (!data) return onCellExit();
  let multiple = "";
  if (data.multiple) {
    multiple = `<p><i>This message was sent to multiple superintendents in our survey.</i>`;
  }
  note.innerHTML = `
<b>From:</b>
<span class="metadata">${data.vendor}</span>
<b>Subject:</b>
<span class="metadata">${data.subject.replace(/Fwd?:\s*/, "")}</span>
<b>Business type:</b>
<span class="metadata">${data.type}</span>

${multiple}
  `;
  note.toggleAttribute("hidden", false);
}

function onCellExit() {
  note.toggleAttribute("hidden", true);
}

for (let cell of cells) {
  cell.addEventListener("mousemove", onCellEnter);
  cell.addEventListener("mouseout", onCellExit);
}